import { render, staticRenderFns } from "./tab-economy.vue?vue&type=template&id=8f425166&"
import script from "./tab-economy.vue?vue&type=script&lang=js&"
export * from "./tab-economy.vue?vue&type=script&lang=js&"
import style0 from "./tab-economy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports